import React from 'react';
import { Board } from '../Board';
import { GAME_CONFIG } from '../../utils';

export const Game = () => (
    <Board boardSize={GAME_CONFIG.BOARD_SIZE} minesNr={GAME_CONFIG.MINES_NR} />
);
